module.exports = __webpack_public_path__ + "26baf76f23f13f669308903e2d9c3346.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots/elf_owl_hoot.mp3
// module id = 4158
// module chunks = 0